import { useEffect, useRef, useState } from 'react';

const useIntersectionObserver = ({ rootElement = null, rootMargin = '0px', threshold = 1.0 }) => {
  const [entry, setEntry] = useState({});
  const [node, setNode] = useState(null);

  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new window.IntersectionObserver(entr => setEntry(entr), {
      root: rootElement,
      rootMargin,
      threshold
    });
    const { current } = observer;
    if (node) {
      current.observe(node);
    }
    return () => {
      if (current) {
        current.disconnect();
      }
    };
  }, [node, rootElement, rootMargin, threshold]);
  return [entry, setNode];
};

export { useIntersectionObserver };
